module.exports = __webpack_public_path__ + "static/media/plus-white.3e44dee3.svg";